import { Card, CardBody, Col, Row } from "reactstrap";
import { GridColumnTitle } from "../../../constants";
import { GridColumnData, GridColumnSubTitle } from "../../../data/uiKits/Grid";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const GridColumn = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={GridColumnTitle} span={GridColumnSubTitle} />
        <CardBody className="grid-showcase">
          <Row>
            {GridColumnData &&
              GridColumnData.map((item, index) => (
                <Col md={item} className="text-center" key={index}>
                  <span>{`col-md-${item}`}</span>
                </Col>
              ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default GridColumn;
